module.exports = __webpack_public_path__ + "img/285.429c5420.png";